import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { loadForCurrentMonth } from '~/components/actions';
import { LoadingTopBar } from '~/components/UI/LoadingTopBar';
import Dashboard from '../components/Dashboard';
import { CACHE_ACTIONS } from '~/constants/cache-actions.constants';
import { LocalCacheHandler } from '~/utils/local-cache-handler';

export const ScreensDashboard = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(function() {
    var isMounted = true;

    async function loadData() {
      try {
        await LocalCacheHandler.load({
          actionName: CACHE_ACTIONS.dashboard,
          dispatch,
          pathname,
        });
        var result = await dispatch(
          loadForCurrentMonth({ showLoading: false })
        );
        await LocalCacheHandler.save({
          pathname,
          data: result.payload.data,
        });
      } catch (error) {
        console.log(error);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    }

    loadData();

    return function() {
      isMounted = false;
    };
  }, []);

  return (
    <>
      <LoadingTopBar isActive={isLoading} />
      <Dashboard />
    </>
  );
};
